// src/apiService.js
import {functions, httpsCallable} from '../firebase';

// Service for interacting with Firebase Functions
const apiService = {

    // Call the createUser function
    createUser: async ({phoneNumber, displayName}) => {
        const createUser = httpsCallable(functions, 'createUser');
        try {
            const result = await createUser({phoneNumber, displayName});
            return result.data.user;
        } catch (error) {
            console.error('Error creating user:', error);
            throw error;
        }
    },

    // Call the getUser function
    getUser: async () => {
        const getUser = httpsCallable(functions, 'getUser');
        try {
            const result = await getUser();
            return result.data.user;
        } catch (error) {
            console.error('Error fetching user:', error);
            throw error;
        }
    },

    // Call the startSession function
    startSession: async () => {
        const startSession = httpsCallable(functions, 'startSession');
        try {
            const result = await startSession();
            return result.data;
        } catch (error) {
            console.error('Error starting session:', error);
            throw error;
        }
    },

    // Call the sendMessage function
    sendMessage: async (sessionId, message) => {
        const sendMessage = httpsCallable(functions, 'sendMessage');
        try {
            const result = await sendMessage({sessionId, message});
            return result.data;
        } catch (error) {
            console.error('Error sending message:', error);
            throw error;
        }
    },

    // Call the getConversationsMetadata function
    getConversationsMetadata: async () => {
        const getConversationsMetadata = httpsCallable(functions, 'getConversationsMetadata');
        try {
            const result = await getConversationsMetadata();
            return result.data?.sessionsMetadata;
        } catch (error) {
            console.error('Error fetching conversations metadata:', error);
            throw error;
        }
    },

    // Call the getConversationData function
    getConversationData: async (sessionId) => {
        const getConversationData = httpsCallable(functions, 'getConversationData');
        try {
            const result = await getConversationData({sessionId});
            return result?.data;
        } catch (error) {
            console.error('Error fetching conversation data:', error);
            throw error;
        }
    },
};

export default apiService;
